export const oneLink = (): string => {
    return "https://smakon-enmusubi.onelink.me/adL2/35f3b994";
};
// 新規会員登録後のときのみ利用
export const oneLinkRegister = (): string => {
    return "https://smakon-enmusubi.onelink.me/adL2/b206ddf4";
};
